module.exports = __webpack_public_path__ + "static/media/trial2_4.cb84e95b.png";